import Component from 'ds-framework/core/Component';

class Carregando extends Component {
  constructor() {
    super('<div></div>');
  }

}

export default Carregando;